module.exports = __webpack_public_path__ + "static/img/kongtiao-chushi-active.0b178ee9.png";